import { PaymentService } from '../../providers'

const PaymentModule = {
  namespaced: true,
  state: {
    charge: [],
    order: undefined
  },
  mutations: {
    SET_CHARGE(state, data) {
      state.charge = data
    },
    SET_ORDER(state, data) {
      state.order = data
    }
  },
  actions: {
    async createCharge({ commit }, attributes) {
      const result = await PaymentService.createCharge(attributes)
      commit('SET_CHARGE', attributes)
      return result
    },
    async createOrder({ commit }, attributes) {
      const result = await PaymentService.createOrder(attributes)
      commit('SET_ORDER', attributes)
      return result
    },
    async createCustomer(_context, params) {
      return PaymentService.createCustomer(params)
    },
    async insertNewCard(_context, { id, params }) {
      return PaymentService.insertNewCard(id, params)
    },
    async inquiryTransaction(context, id) {
      const result = await PaymentService.inquiryTransaction(id)
      return result
    }
  }
}

export default PaymentModule
